import { FormGroup, AbstractControl } from '@angular/forms';

export class FormValidator {

  private form: FormGroup;

  constructor(form: FormGroup) {
    this.form = form;
  }

  updateForm(form: FormGroup) {
    this.form = form;
  }

  isValid(): boolean {
    this.touchFields(this.form);
    return this.form.valid;
  }

  hasErrorOn(field: string): boolean {
    const input = this.findControl(field);
    return input && input.invalid && input.touched;
  }

  findControl(field: string): AbstractControl {
    return this.form.get(field);
  }

  private touchFields(formGroup: FormGroup): void {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.touchFields(control);
      }
    });
  }
}
